import React from 'react';
import ErrorPage from './ErrorPage.js';

const Forbidden = () => (
  <ErrorPage
    code="403"
    title="Forbidden"
    message="You don't have permission to access this page."
  />
);

export default Forbidden;
